import { createContext } from 'react';
import type { AdminSession } from './adminAuth';
export const AdminSessionContext=createContext<AdminSession|null>(null);
